/*
 * AdminUsers Messages
 *
 * This contains all the text for the AdminUsers component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  importParentMails: {
    id: 'app.components.AdminUsers.importParentMails',
    defaultMessage: 'Import Parents Email Addresses',
  },
  importEmployees: {
    id: 'app.components.AdminUsers.importEmployees',
    defaultMessage: 'Import Employees',
  },
  importEmployeeMails: {
    id: 'app.components.AdminUsers.importEmployeeMails',
    defaultMessage: 'Import Employee Email Addresses',
  },
  users: {
    id: 'app.containers.Dashboard.users',
    defaultMessage: 'Users',
  },
  importEmployeesFields: {
    id: 'app.components.AdminUsers.importEmployeesFields',
    defaultMessage: 'First Name|Last Name|Group Name (will be created as \'\'Class\'\' if it does not exist)',
  },
  selectFile: {
    id: 'app.components.SelectFiles.any',
    defaultMessage: 'Select file',
  },
  selectFileIntro: {
    id: 'app.components.SelectFiles.selectFileIntro',
    defaultMessage: 'Your file must have the following columns, you can use <a>our template</a>:',
  },
});
